import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SumePipesModule } from 'src/app/pipes/sume-pipes.module';
import { IconButtonModule } from '../icon-button/icon-button.module';
import { ListItemsComponent } from './list-items.component';

@NgModule({
    declarations: [ListItemsComponent],
    exports: [ListItemsComponent],
    imports: [CommonModule, IconButtonModule, SumePipesModule, NgbModule],
})
export class ListItemsModule {}
